export function normalizeUrl(url) {
    return url.replace(/\/\//g, '/');
}
